import {
  equipmentTypeSeed,
  supplierSeed,
} from '../data/trainingCourseOptions'

export type TrainingOptionKind = 'equipmentType' | 'supplier'

type Listener = () => void

// Self-feeding option lists shared by every course form
class TrainingOptionsStore {
  private options: Record<TrainingOptionKind, string[]> = {
    equipmentType: [...equipmentTypeSeed],
    supplier: [...supplierSeed],
  }
  private listeners = new Set<Listener>()

  getAll(): Record<TrainingOptionKind, string[]> {
    return this.options
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  add(kind: TrainingOptionKind, value: string): string {
    const trimmed = value.trim()
    const existing = this.options[kind].find(
      (o) => o.toLowerCase() === trimmed.toLowerCase(),
    )
    if (existing) return existing
    this.options = { ...this.options, [kind]: [...this.options[kind], trimmed] }
    this.listeners.forEach((l) => l())
    return trimmed
  }
}

export const trainingOptionsStore = new TrainingOptionsStore()
